<template>
  <div class="description">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  .description {
    text-align: center;
    color: #334d5d;
    max-width: 800px;
    font-size: 18px;
    line-height: 25px;
    margin: 30px auto 0;

    .section--dark & {
      color: rgba(#fff, 0.7);
    }
  }
</style>